import { PAGINATION_OFFSET } from "../utils/general";
import { fetch, post } from "./base";

export const fetchUserDetails = async (cache = false) => {
  if (process.env.REACT_APP_NODE_ENV === "local") {
    return fetch(process.env.REACT_APP_USER_API_URL, {
      cache,
      thirdParty: true,
    });
  }
  return fetch("/me", { cache });
};

export const logout = async () => {
  return fetch("/accounts/logout", { cache: false });
};

export const fetchUserMedia = async (userId, cache = false) => {
  return fetch(`/userimages/?userId=${userId}`, { cache: false });
};

export const fetchUserMusics = async (userId, cache = false) => {
  return fetch(`/userbgaudio/?userId=${userId}`, { cache });
};

export const redeemPoint = async (data, cache = false) => {
  return post("/apply_coupon/", {
    ...data,
  });
};

export const fetchUserTemplates = async (
  userId,
  page,
  search,
  offset,
  cache = false
) => {
  return post(`/core/user-templates/?userId=${userId}`, {
    offset: (page || 0) * PAGINATION_OFFSET,
    length: offset || PAGINATION_OFFSET,

    search: { value: search || "", regex: false },
  });
};
export const fetchUserTemplateById = async (id, cache = false) => {
  return fetch(`/core/user-templates/${id}`, { cache });
};
